module.exports = __webpack_public_path__ + "static/media/toggle-on.6043e627.svg";